import moment from 'moment';

export const formatDate = (date: Date | string) => {
  if (typeof date === 'string') {
    return moment(date).format('YYYY-MM-DD');
  }

  date = new Date(date);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  if ([day, month, year].includes(NaN)) {
    return null;
  }
  return `${year}-${month < 10 ? `0${month}` : month}-${
    day < 10 ? `0${day}` : day
  }`;
};
